<template>
  <div class="pub-home">
    <el-card class="main">
      <el-form :model="pass" :rules="rules" ref="passFrom">
        <el-form-item prop="password">
          <el-input
            name="password"
            type="password"
            v-model="pass.password"
            placeholder="请输入原密码"
            show-password
          >
            <span slot="prefix">
              <svg-icon icon-class="password" class="color-main"></svg-icon>
            </span>
          </el-input>
        </el-form-item>
        <el-form-item prop="npassword">
          <el-input
            name="npassword"
            type="password"
            v-model="pass.npassword"
            placeholder="请输入新密码"
            show-password
          >
            <span slot="prefix">
              <svg-icon icon-class="password" class="color-main"></svg-icon>
            </span>
          </el-input>
          <span style="font-size:12px;color:green">密码长度大于10,且必须包含大写、小写、数字、特殊字符(!@#$%^&*.)！</span>
        </el-form-item>
        <el-form-item prop="npassword2">
          <el-input
            name="npassword2"
            type="password"
            v-model="pass.npassword2"
            placeholder="新密码确认"
            show-password
          >
            <span slot="prefix">
              <svg-icon icon-class="password" class="color-main"></svg-icon>
            </span>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            v-model="pass.code"
            auto-complete="off"
            placeholder="验证码"
            style="width: 50%; float: left"
          >
            <span slot="prefix">
              <svg-icon icon-class="ums" class="color-main" />
            </span>
          </el-input>
          <div class="login-code">
            <img :src="codeData" @click="getCode" class="login-code-img" />
          </div>
        </el-form-item>
        <el-form-item label="">
          <el-button
            type="primary"
            :loading="loading"
            @click.native.prevent="onSubmit('passFrom')"
          >
            更改密码
          </el-button>
          <el-button type="primary" @click.native.prevent="close">
            关闭
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getPassCode, updatePassWord } from "@/api/login.js";
import { isEmpty,stringToBase64AES } from "@/utils/help";
const defaultPass = {
  password: "",
  npassword: "",
  code: "",
};
export default {
  name: "Pass",
  data() {
    const validatePassword = (rule, value, callback) => {
      const passwordMgx = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\._\+(){}])[0-9a-zA-Z!@#$%^&*,\\._\+(){}]{10,100}$/;
      if (!passwordMgx.test(value)) {
        callback(new Error("密码长度大于10,且必须包含大写、小写、数字、特殊字符(!@#$%^&*.)！"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (
        !isEmpty(this.pass.npassword) &&
        !isEmpty(value) &&
        value != this.pass.npassword
      ) {
        callback(new Error("两次密码输入不一致"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      codeData: "",
      pass: Object.assign({}, defaultPass),
      rules: {
        password: [
          { required: true, message: "请输入原密码", trigger: "blur" },
        ],
        npassword: [
          { required: true, message: "新密码长度必须大于10,且包含大写、小写、数字、特殊字符(!@#$%^&*.)！", trigger: "blur", validator: validatePassword },
        ],
        npassword2: [{ trigger: "blur", validator: validatePass }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getCode();
  },
  methods: {
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    onSubmit(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        //密码长度大于10,且必须包含大写、小写、数字、特殊字符
        var validatePassword =/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\._\+(){}])[0-9a-zA-Z!@#$%^&*,\\._\+(){}]{10,20}$/;
        if (!validatePassword.test(this.pass.npassword)){
          this.$message.error(
            "密码长度大于10,且必须包含大写、小写、数字、特殊字符(!@#$%^&*.)！"
          );
          this.loading = false;
          valid = false;
          return false;
        }
        if (valid) {
           this.pass.npassword=stringToBase64AES(this.pass.npassword);
           this.pass.password=stringToBase64AES(this.pass.password);
            updatePassWord(this.pass)
              .then((response) => {
                this.loading = false;
                this.$message({
                  message: "修改密码成功",
                  type: "success",
                  duration: 3000,
                });
                let _this = this;
                setTimeout(function () {
                  _this.logout();
                }, 4000);
              })
              .catch((res) => {
                this.loading = false;
              });
        } else {
          this.loading = false;
          this.$message({
            message: "验证失败",
            type: "error",
            duration: 1000,
          });
          return false;
        }
      });
    },
    close() {
      this.$emit("cancel");
    },
    getCode() {
      getPassCode().then((res) => {
        this.codeData = URL.createObjectURL(res);
      });
    },
  },
};
</script>

<style scoped>
.pub-home {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main {
  background: #fff;
  width: 400px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/PassWord.vue